import { motion } from 'framer-motion';
import PersonIcon from '@mui/icons-material/PersonRounded';
import SecurityIcon from '@mui/icons-material/SecurityRounded';
import NotificationsIcon from '@mui/icons-material/NotificationsActiveRounded';
import './Settings.scss';

export default function Settings() {
  const sections = [
    {
      id: 'profile',
      title: 'Profile Settings',
      icon: <PersonIcon />,
      items: ['Edit Name', 'Profile Picture', 'Bio']
    },
    {
      id: 'account',
      title: 'Account Security',
      icon: <SecurityIcon />,
      items: ['Change Password', 'Two-Factor Authentication', 'Sessions']
    },
    {
      id: 'notifications',
      title: 'Notifications',
      icon: <NotificationsIcon />,
      items: ['Email Alerts', 'Push Notifications', 'Weekly Summary']
    }
  ];

  return (
    <div className="settings-page">
      <header className="settings-page__header">
        <h1>Settings</h1>
        <p>Manage your account settings and preferences.</p>
      </header>

      <div className="settings-page__grid">
        {sections.map((section, idx) => (
          <motion.section
            key={section.id}
            className="settings-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1 }}
          >
            <div className="settings-card__header">
              <div className="settings-card__icon">{section.icon}</div>
              <h3>{section.title}</h3>
            </div>
            <ul className="settings-card__list">
              {section.items.map(item => (
                <li key={item} className="settings-card__item">
                  <span>{item}</span>
                  <button className="settings-card__btn">Edit</button>
                </li>
              ))}
            </ul>
          </motion.section>
        ))}
      </div>
    </div>
  );
}
